import axios from "axios";
import Utils from "./Utils";
import { refreshTokenApi } from "../api/common";

const getIp = localStorage.getItem("ipAddress");

const detectOS = () => {
  const platform = navigator.platform;
  if (platform.startsWith("Win")) {
    return "WINDOWS_OS";
  } else if (platform.startsWith("Mac")) {
    return "MAC_OS";
  } else if (platform.startsWith("Linux")) {
    return "LINUX_OS";
  }
};

let userDetail = Utils.getUserDetail();
const axiosInstance = axios.create({
  baseURL:
    window.location.hostname == "localhost"
      ? "https://platform.dev.hireplusplus.com"
      : window.location.origin,
  headers: {
    ...(userDetail && {
      Authorization: "Bearer " + userDetail.accessToken,
      username: "abcd",
      userIdentifier: userDetail.userIdentifier,
    }),
  },
});

function getCurrentFormattedTime() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
  const day = String(now.getDate()).padStart(2, "0");

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}
const rememberMeFlag =
  localStorage.getItem("rememberMe") === "true" ? true : false;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    let userDetail = Utils.getUserDetail();
    let refreshToken = "";

    // Get rememberMeFlag from localStorage (or sessionStorage if needed)
    const rememberMeFlag = JSON.parse(localStorage.getItem("rememberMe") || "false");

    // If user is not logged in, redirect immediately
    if (!userDetail) {
      window.location.href = `/login?redirect=${encodeURIComponent(
        window.location.pathname + window.location.search
      )}`;
      return Promise.reject(error);
    }

    if (userDetail && userDetail.refreshToken) {
      refreshToken = userDetail.refreshToken;
    }

    // Handle only 401 Unauthorized errors
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      // ✅ If rememberMeFlag is false → directly redirect to login
      if (!rememberMeFlag) {
        Utils.removeUserDetail();
        window.location.href = `/login?redirect=${encodeURIComponent(
          window.location.pathname + window.location.search
        )}`;
        return Promise.reject(error);
      }

      // ✅ If rememberMeFlag is true → try refresh token API
      try {
        const myHeaders = new Headers();
        myHeaders.append("userIdentifier", userDetail.userIdentifier);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          refreshToken: refreshToken,
          sessionInfo: {
            deviceId: detectOS(),
            ipAddress: getIp,
            dateTimeInfo: getCurrentFormattedTime(),
            loginValidationResult: "string",
            deviceInfo: {},
          },
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        // Call refresh token API
        const result = await fetch(refreshTokenApi, requestOptions);
        const response = await result.json();

        if (response && response.data && response.data.accessToken) {
          // ✅ Successfully refreshed token
          const newUserDetail = {
            accessToken: response.data.accessToken,
            accessTokenExpiresIn: response.data.accessTokenExpiresIn,
            refreshToken: response.data.refreshToken,
            tokenType: "Bearer",
            userRole: userDetail.userRole,
            userIdentifier: userDetail.userIdentifier,
          };

          Utils.setUserDetail(newUserDetail);

          // Update authorization headers
          axios.defaults.headers["Authorization"] =
            "Bearer " + newUserDetail.accessToken;
          originalRequest.headers["Authorization"] =
            "Bearer " + newUserDetail.accessToken;

          // Retry the failed request
          return axios(originalRequest);
        } else {
          // ❌ Refresh failed → redirect to login
          Utils.removeUserDetail();
          window.location.href = `/login?redirect=${encodeURIComponent(
            window.location.pathname + window.location.search
          )}`;
          return Promise.reject(error);
        }
      } catch (err) {
        // ❌ Refresh API call failed → redirect to login
        Utils.removeUserDetail();
        window.location.href = `/login?redirect=${encodeURIComponent(
          window.location.pathname + window.location.search
        )}`;
        return Promise.reject(err);
      }
    }

    // ✅ For other errors (400, 403, 404, 500, etc.), do NOT redirect
    return Promise.reject(error);
  }
);


const setHeaderParams = () => {
  let userDetail = Utils.getUserDetail();
  if (userDetail) {
    axios.defaults.headers.common = {
      authorization: "Bearer " + userDetail.accessToken,
      username: "abcd",
      userId: userDetail.userIdentifier,
    };
  }
};
const setHeaderParamsClientId = () => {
  let userDetail = Utils.getUserDetail();
  let userClient = sessionStorage.getItem("clientIdHeader");
  if (userDetail && userClient) {
    axios.defaults.headers.common = {
      authorization: "Bearer " + userDetail.accessToken,
      username: "abcd",
      userId: userDetail.userIdentifier,
      clientId: userClient,
    };
  }
};

const WebUtils = {
  httpOperations: (
    url,
    data,
    httpMethod = undefined,
    responseType = undefined,
    noAuth = false
  ) => {
    setHeaderParams();

    if (noAuth) {
      delete axios.defaults.headers.common.username;
      delete axios.defaults.headers.common.userId;
      delete axios.defaults.headers.common.authorization;
    }

    if (httpMethod === "GET") {
      return axios.get(url, { params: data }).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "DELETE") {
      return axios.delete(url, { data }).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "POST" && responseType !== "formData") {
      return axios.post(url, data).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "POST" && responseType === "formData") {
      return axios
        .post(url, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(
          (success) => Promise.resolve(success),
          (error) => Promise.reject(error)
        );
    } else if (httpMethod === "PUT") {
      return axios.put(url, data).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    }
  },
  httpOperationsHeader: (
    url,
    data,
    httpMethod = undefined,
    responseType = undefined,
    noAuth = false
  ) => {
    setHeaderParamsClientId();

    if (noAuth) {
      delete axios.defaults.headers.common.username;
      delete axios.defaults.headers.common.userId;
      delete axios.defaults.headers.common.authorization;
    }

    // console.log(data)
    if (httpMethod === "GET") {
      return axios.get(url, { params: data }).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "DELETE") {
      return axios.delete(url, { data }).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "POST" && responseType !== "formData") {
      return axios.post(url, data).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "POST" && responseType === "formData") {
      return axios
        .post(url, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(
          (success) => Promise.resolve(success),
          (error) => Promise.reject(error)
        );
    } else if (httpMethod === "PUT") {
      return axios.put(url, data).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    }
  },
  getProctorBaseUrl: () => {
    if (window.location.hostname === "localhost") {
      return "https://platform.dev.jobdrona.com";
    } else {
      return window.location.origin;
    }
  },
  getHireBaseUrl: () => {
    if (
      window.location.hostname === "localhost" ||
      window.location.hostname === "platform.dev.jobdrona.com"
    ) {
      return "https://dev.hireplusplus.com";
    } else {
      return "https://hireplusplus.com";
    }
  },
};

export default WebUtils;
